import axios from 'axios'

const state = {
    tagline: 'Changing Your Food Experience',
    app_name: 'Food Park',
    email: 'enquiry@foodpark.ng',
    telephone1: '+234 906 282 2258',
    telephone2: '+234 904 604 0991', // Lagos
    telephone3: '+234 906 243 1189',
    telephone4: '+234 904 300 8269', // Ibadan
    telephone5: '+234 814 308 8123', // Abeokuta
    address: '20, Oba Ogunnusi Road, Akiode Bus-stop, Ojodu Berger, Lagos',
    address2: '3, Moremi Crescent, Off Aare Avenue, New Bodija, Ibadan',
    address3: 'No 52, Omida Shopping Complex, Ibara, Abeokuta',
    facebook: ' https://www.facebook.com/Foodpark-108913344131907/ ',
    twitter: '',
    instagram: 'https://www.instagram.com/foodpark__/',
    
}
const getters = { 


}
const mutations = { 

    
}
const actions = {




    





}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}






